import React from "react";
import {Table} from "react-bootstrap";
import HeaderWithHelp from "../SalesAnalysis/HeaderWithHelp.jsx";
import {formatDatum, formatMenge} from "./format.js";

/**
 * Offene Kundenaufträge dieses Farbtons (article_reservations, enge
 * Definition F4: Status "Auftrag wird erfasst" / "Auftragsbestätigung
 * gedruckt"). Leere Liste verschwindet vollständig.
 */
export default function ArtikelOffeneAuftraege({auftraege}) {
    if (!auftraege || auftraege.length === 0) {
        return null;
    }

    return (
        <Table size="sm" hover responsive className="mb-0">
            <thead>
                <tr className="small text-muted">
                    <th>
                        <HeaderWithHelp help="Auftragsnummer im B2B-Shop.">Auftrag</HeaderWithHelp>
                    </th>
                    <th>
                        <HeaderWithHelp help="Name des Kunden.">Kunde</HeaderWithHelp>
                    </th>
                    <th>
                        <HeaderWithHelp help="Datum, an dem der Auftrag angelegt wurde.">Datum</HeaderWithHelp>
                    </th>
                    <th>
                        <HeaderWithHelp help="Bearbeitungsstand des Auftrags im Shop.">Status</HeaderWithHelp>
                    </th>
                    <th>
                        <HeaderWithHelp help="Wer den Auftrag im Shop bearbeitet.">Zuständig</HeaderWithHelp>
                    </th>
                    <th className="text-end">
                        <HeaderWithHelp help="Noch nicht versandte Menge dieses Auftrags.">Offene Menge</HeaderWithHelp>
                    </th>
                </tr>
            </thead>
            <tbody>
                {auftraege.map((a) => (
                    <tr key={a.order_number}>
                        <td className="small">
                            {a.weclapp_url ? (
                                <a href={a.weclapp_url} target="_blank" rel="noopener noreferrer">
                                    {a.order_number}
                                </a>
                            ) : (
                                a.order_number
                            )}
                        </td>
                        <td className="small">{a.customer_name}</td>
                        <td className="small">{formatDatum(a.order_date)}</td>
                        <td className="small">{a.order_status_label}</td>
                        <td className="small">{a.responsible_user_name || "–"}</td>
                        <td className="text-end">{formatMenge(a.quantity_open)}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
}
